import {
  FAIL_FETCH,
  FETCH_PUSH_CONTENT_NOTIFICATIONS,
  LOAD_PUSH_CONTENT_NOTIFICATIONS,
  FETCH_PUSH_EVENT_NOTIFICATIONS,
  LOAD_PUSH_EVENT_NOTIFICATIONS,
  LOAD_PUSH_ALERT_NOTIFICATIONS,
  FETCH_PUSH_ALERT_NOTIFICATIONS,
  FETCH_PUSH_SMS_NOTIFICATIONS,
  LOAD_PUSH_SMS_NOTIFICATIONS
} from '../Actions/Notifications'

const emptyPushNotification = {
  title: '',
  totalSent: '',
  totalDelivered: '',
  totalFailed: '',
  createdDate: '',
  lastOneSignalAPIUpdated: ''
}
const initialState = {
  pushNotifications: [emptyPushNotification.title = 'OFFLINE']
}
/**
 * NotificationReducer
 * @desc reducer that handles data displayed on the Notifications page
 * @param {Object} state
 * @param {action} action
 * @return {Object} state updated state
 */
export default function NotificationReducer (state, action) {
  if (typeof state === 'undefined') {
    return initialState
  }
  switch (action.type) {
    case FETCH_PUSH_CONTENT_NOTIFICATIONS:
      return Object.assign({}, state, { pushContentNotifications: [Object.assign({}, emptyPushNotification, { title: 'Loading' })], pushContentNotificationsLength: 0 })
    case LOAD_PUSH_CONTENT_NOTIFICATIONS:
      return Object.assign({}, state, { pushContentNotifications: action.data.allPushNotifications.pushNotifications, pushContentNotificationsLength: action.data.allPushNotifications.count })
    case FETCH_PUSH_ALERT_NOTIFICATIONS:
      return Object.assign({}, state, { pushAlertNotifications: [Object.assign({}, emptyPushNotification, { title: 'Loading' })], pushAlertNotificationsLength: 0 })
    case LOAD_PUSH_ALERT_NOTIFICATIONS:
      return Object.assign({}, state, { pushAlertNotifications: action.data.allPushNotifications.pushNotifications, pushAlertNotificationsLength: action.data.allPushNotifications.count })
    case FETCH_PUSH_SMS_NOTIFICATIONS:
      return Object.assign({}, state, { pushSmsNotifications: [Object.assign({}, emptyPushNotification, { title: 'Loading' })], pushAlertNotificationsLength: 0 })
    case LOAD_PUSH_SMS_NOTIFICATIONS:
      return Object.assign({}, state, { pushSmsNotifications: action.data.allPushNotifications.pushNotifications, pushSmsNotificationsLength: action.data.allPushNotifications.count })
    case FETCH_PUSH_EVENT_NOTIFICATIONS:
      return Object.assign({}, state, { pushEventNotifications: [Object.assign({}, emptyPushNotification, { title: 'Loading' })], pushEventNotificationsLength: 0 })
    case LOAD_PUSH_EVENT_NOTIFICATIONS:
      return Object.assign({}, state, { pushEventNotifications: action.data.allPushNotifications.pushNotifications, pushEventNotificationsLength: action.data.allPushNotifications.count })
    case FAIL_FETCH:
      return state
    default:
      return state
  }
}
